import React from 'react';
import { useAITTheme } from '../ui/theme';

const StationIcon: React.FC = () => {
  const { theme } = useAITTheme();
  return (
    <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 512 512">
      <path
        fill={theme.tokens.colors.brand.primary}
        d="M115.95,377.38h280.11c21.01,0,38.08-17.02,38.08-38.06V109.25c0-52.59-42.62-95.22-95.2-95.22h-165.89c-52.56,0-95.18,42.62-95.18,95.22v230.06c0,21.02,17.06,38.06,38.08,38.06h0ZM384.51,143.17v73.95h-108.51v-73.95h108.51ZM337.69,83.73h0c0,9.34-7.57,16.91-16.91,16.91h-129.54c-9.34,0-16.91-7.57-16.91-16.91h0c0-9.34,7.57-16.91,16.91-16.91h129.54c9.34,0,16.91,7.57,16.91,16.91ZM127.49,143.17h108.5v73.95h-108.5v-73.95Z"
      />
      <path
        fill={theme.tokens.colors.brand.primary}
        d="M404.06,497.97h47.86l-70.32-92.03h-47.87l19.1,25.01h-193.68l19.1-25.01h-47.86l-70.32,92.03h47.84l24.74-32.37h246.69l24.72,32.37Z"
      />
    </svg>
  );
};

export default StationIcon;
